// src/components/Footer.js
import '../styles/Footer.css';
import { FaWhatsapp } from 'react-icons/fa';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../constants/appLinks';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-container">
            <div className="footer-inner">
                <div className="footer-brand">
                    <div className='footer-main'>
                        <div className='footer-etikaf'>
                            <img
                                src="/assets/e-icon.png"
                                className="footer-icon"
                                alt="Etikaf logo"
                                onClick={() => window.location.href = '/'}
                            />
                        </div>
                        <div className="footer-logos">
                            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Muat turun Etikaf di App Store">
                                <img src="/assets/apple.png" className="footer-store" alt="" />
                            </a>
                            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" aria-label="Muat turun Etikaf di Google Play">
                                <img src="/assets/google.png" className="footer-play" alt="" />
                            </a>
                        </div>
                    </div>

                    <div className='footer-socials'>
                        <div className="footer-text">
                            &copy; 2017-{currentYear} Etikaf Ent.
                        </div>
                        <a
                            className="footer-pill footer-pill-whatsapp"
                            href="https://wa.me/601158885060?text=Assalamualaikum.%20Saya%20ingin%20bertanya%20tentang%20Etikaf."
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Hubungi Etikaf melalui WhatsApp"
                        >
                            <FaWhatsapp className="footer-pill-icon" aria-hidden="true" />
                            <span>Hubungi</span>
                        </a>
                    </div>
                </div>

                <nav className='footer-center' aria-label="Pautan Etikaf">
                    <a href='/my'>Pengenalan</a>
                    <a href='/admin'>Admin</a>
                    <a href='/etv'>ETV</a>
                    <a href='/asatizah'>Asatizah</a>
                    <a href='/kerjaya'>Kerjaya</a>
                    <a href='/privasi'>Privasi</a>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
